import React, { Fragment, useCallback, useState } from 'react';

import { PageSegmentLoadStart } from '@confluence/browser-metrics';
import { LoadablePaint } from '@confluence/loadable';
import { ExperienceStart, HOME_SPACES_EXPERIENCE } from '@confluence/experience-tracker';

import { LazyAdministration, LazySpaces } from './index';

import { HOME_OVERVIEW_SPACES_SECTION_SEGMENT } from '../../perf.config';
import { useLoadingListener } from '../RightPanel/LoadingListener';

export const LeftPanelExtendedItems = () => {
	const { administrationOnLoad, spacesOnLoad } = useLoadingCallbacks();
	return (
		<Fragment>
			<PageSegmentLoadStart metric={HOME_OVERVIEW_SPACES_SECTION_SEGMENT} />
			<ExperienceStart name={HOME_SPACES_EXPERIENCE} />
			<LazyAdministration onLoad={administrationOnLoad} />
			<LazySpaces onLoad={spacesOnLoad} />
		</Fragment>
	);
};

export const LazyLeftPanelExtendedItems = LoadablePaint({
	loader: async () => LeftPanelExtendedItems,
});

const useLoadingCallbacks = () => {
	const [leftPanelLoading, setLeftPanelLoading] = useState(true);

	const sectionsToListenFor = ['administration', 'spaces'];

	const dispatchOnLoad = useLoadingListener(sectionsToListenFor, () => {
		setLeftPanelLoading(false);
	});

	const administrationOnLoad = useCallback(
		() => dispatchOnLoad('administration'),
		[dispatchOnLoad],
	);

	const spacesOnLoad = useCallback(() => dispatchOnLoad('spaces'), [dispatchOnLoad]);

	return {
		leftPanelLoading,
		administrationOnLoad,
		spacesOnLoad,
	};
};
